import React, { useEffect, useState } from 'react';
import useMarketPlaceModal from "./useMarketPlaceModal";
import LoadingButton from '../../../../utility/button/LoadingButton';
import marketPlace1 from "../../../../../images/growth-analytics.png";
import marketPlace2 from "../../../../../images/real-time-sync.png";
import marketPlace3 from "../../../../../images/cloud-hosting.png";

const MarketplaceModalNew = () => {
  const { loading, handleConnect, marketplaceData, getMarketplaces } = useMarketPlaceModal();
  const [loadingMarketplace, setLoadingMarketplace] = useState(null); // null or marketplace name

  // Fetch marketplace data on mount
  useEffect(() => {
    getMarketplaces();
  }, []);


  return (
        <div
      className="d-flex justify-content-center align-items-center min-vh-100 px-3 market-place-modal"
    >
    <div className="container market-place-modal">
      <div className="text-center mb-5">
        <h2 className="display-5 market-place-heading">Connect Your Marketplace Accounts</h2>
        <p className="market-place-subheading">Easily integrate with popular marketplaces to centralize data, automate workflows, and grow your business.</p>
      </div>

      <div className="row text-center">
        {/* Centralized Inventory */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 marketplace-card h-100">
            <div className="card-body">
              <h5 className="card-heading text-purple">Centralized Inventory</h5>
              <p className="card-text">Manage all your products and stock levels in one place, across platforms.</p>
              <div className="d-flex justify-content-center">
                <img src={marketPlace3} alt="report" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>

        {/* Unified Reporting */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 marketplace-card h-100">
            <div className="card-body">
              <h5 className="card-heading text-purple">Unified Reporting</h5>
              <p className="card-text">Track orders, revenue, and performance metrics from all marketplaces in one dashboard.</p>
              <img src={marketPlace1} alt="report" className="img-fluid" />
            </div>
          </div>
        </div>

        {/* Automated Syncing */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 marketplace-card h-100">
            <div className="card-body">
              <h5 className="card-heading text-purple">Automated Syncing</h5>
              <p className="card-text">Ensure your listings, prices, and inventory are always up to date automatically.</p>
              <img src={marketPlace2} alt="sync" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
      <div className="text-center  mb-4">
        <div className='btn-div-heading'>Select profile and connect account to continue</div>
            <div className="  p-4 rounded overflow-auto hide-scrollbar">
            <div className="d-flex g-4 justify-content-center">
              {marketplaceData.map((marketplace) => {
                const isComingSoon = marketplace.coming_soon;
                const isLoading = loadingMarketplace === marketplace.name;

                return (
                  <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={marketplace.name}>
                    <div className="marketplace-card d-flex h-100 text-center p-3 rounded flex-column justify-content-between">
                      <img
                        src={marketplace.logo_url}
                        alt={marketplace.name || "Galapalyze logo"}
                        className="marketplace-icon mb-2"
                        style={{ height: 100, objectFit: 'contain' }}
                      />
                      <LoadingButton
                        disabled={isComingSoon || isLoading}
                        isLoading={isLoading}
                        onClick={() => {
                          if (!isComingSoon) {
                            setLoadingMarketplace(marketplace.name);
                            handleConnect(marketplace.name).finally(() => {
                              setLoadingMarketplace(null);
                            });
                          }
                        }}
                      >
                        {isComingSoon ? "Coming Soon" : "Connect"}
                      </LoadingButton>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          
                  {/* <button className="btn update-plan-btn">Update Plan</button> */}
          </div>
      {/* <div className="text-center btn-div-heading mb-4">
        <div>Select profile and connect account to continue</div>
        <div className='brand-div'>
          

        </div>

        <button className="btn update-plan-btn">Update Plan</button>
      </div> */}

      <div className="text-center text-muted">
        <p className='mb-0' style={{color: 'var(--body-text-color)'}}>Your privacy is our priority. We comply with industry standards including GDPR and SOC 2.</p>
      </div>
    </div>
    </div>
  );
};

export default MarketplaceModalNew;
